/** HOW TO USE THIS FILE?
 * 
 *  1.Create similar file for each type of input required.
 *  2. Import this file in your main file.(eg. UpdateDevicePolicy.js)
 *  3. Pass this to DynamicForm.js file to generate input fields.
 * 
 */

export const devicePolicyFormFields = [
    {
        name: 'name',
        label: 'Policy Name',
        type: 'text',
        required: true,
        placeholder: 'Enter Policy Name',
        className: 'policyName',
        rules: {
            maxLength: {
                value: 128,
                message: "Maximum 128 characters are allowed.",
            },
            pattern: {
                value: /^[a-zA-Z0-9-_]+$/,
                message: "Only alphabets, numbers, hyphens(-) or underscores(_) allowed. (No spaces)",
            }
        },
    },
    {
        name: 'description',
        label: 'Policy Description',
        type: 'textarea',
        rows: '3',
        required: false,
        placeholder: 'Enter Policy Description',
        className: 'policyDescription',
        rules: {
            minLength: {
                value: 2,
                message: "Minimum 2 characters required.",
            },
            maxLength: {
                value: 255,
                message: "Maximum 255 characters are allowed.",
            }
        },
    },
    {
        name: 'policyJson',
        label: 'Policy Json',
        type: 'textarea',
        rows: '7',
        required: true,
        placeholder: 'Enter Policy Json',
        className: 'policyJson',
        isJson: true,
        rules: {
            minLength: {
                value: 0,
                message: "Minimum 147 characters required.",
            },
            maxLength: {
                value: 2048,
                message: "Maximum 2048 characters are allowed.",
            },
            validate: (value) => {
                try {
                    JSON.parse(value);
                    return true;
                } catch (error) {
                    return "Invalid JSON format";
                }
            }
        },
    },
];
